import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import CommercialsClient from "../MasterTemplate/CommercialsClient";
import CommercialsSuplier from "./CommercialsSuplier";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "4rem",
    marginLeft: "58px",
  },
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
  tab: {
    "& button": {
      borderTopLeftRadius: "7px",
      fontSize: "15px",
      fontFamily: "Open Sans",
      marginRight: "20px",
      borderTopRightRadius: "7px",
      flexGrow: "inherit",
      backgroundColor: "#F8F8F8",
      textTransform: "capitalize",
      border: "1px solid #E9E9F0",
      color: "#008080",
      opacity: "0.2",
    },
  },
  indicator: {
    backgroundColor: "red",
  },
  clientSelected: {
    backgroundColor: '#00808080 !important',
    color: '#ffffff'
  },
  supplierSelected: {
    backgroundColor: '#008080 !important',
    color: '#ffffff'
  },

  newStyle: {
    '&$clientSelected': {
      backgroundColor: '#3B86FF',
      color: '#ffffff'
    },
    '&$supplierSelected': {
      backgroundColor: '#3B86FF',
      color: '#ffffff'
    },
  }

}));

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const CommercialsBilling = (props) => {
  const {
    handleClose,
    setStepperData,
    setHeaderType,
    setFetchApiFlag,
    fetchApiFlag,
  } = props;
  const theme = useTheme();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [programPriceSummary, setProgramPriceSummary] = useState(undefined);
  const [programForCoach, setProgramForCoach] = useState(undefined);
  const [elementPriceSummary, setElementPriceSummary] = useState(undefined);
  const [elementForCoach, setElementForCoach] = useState(undefined);

  const [country, setCountry] = useState("");
  const [rateCardType, setRateCardType] = useState("");
  const [level, setLevel] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className={classes.root}>
        <Tabs
          TabIndicatorProps={{
            style: {
              display: "none",
            },
          }}
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          className={classes.tab}
          aria-label="full width tabs example"
        >
          <Tab
            variant="contained"
            className={classes.newStyle}
            classes={{
              indicator: classes.indicator,
              selected: classes.clientSelected,
            }}
            label="Client"
            {...a11yProps(0)}
          />
          <Tab
            className={classes.newStyle}
            classes={{
              indicator: classes.indicator,
              selected: classes.supplierSelected,
            }}
            label="Supplier"
            {...a11yProps(1)}
            disabled={value === 0}
          />
        </Tabs>

        <TabPanel value={value} index={0} dir={theme.direction}>
          <CommercialsClient
            setProgramPriceSummary={setProgramPriceSummary}
            programPriceSummary={programPriceSummary}
            setProgramForCoach={setProgramForCoach}
            programForCoach={programForCoach}
            setElementPriceSummary={setElementPriceSummary}
            elementPriceSummary={elementPriceSummary}
            setElementForCoach={setElementForCoach}
            elementForCoach={elementForCoach}
            setTabIndex={setValue}
            tabIndex={value}
            {...props}
            setHeaderType={setHeaderType}
            setStepperData={setStepperData}
            setFetchApiFlag={setFetchApiFlag}
            fetchApiFlag={fetchApiFlag}
            setCountry={setCountry}
            setRateCardType={setRateCardType}
            setLevel={setLevel}
          />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <CommercialsSuplier
            setProgramPriceSummary={setProgramPriceSummary}
            programPriceSummary={programPriceSummary}
            setProgramForCoach={setProgramForCoach}
            programForCoach={programForCoach}
            setElementPriceSummary={setElementPriceSummary}
            elementPriceSummary={elementPriceSummary}
            setElementForCoach={setElementForCoach}
            elementForCoach={elementForCoach}
            setTabIndex={setValue}
            tabIndex={value}
            {...props}
            setHeaderType={setHeaderType}
            setStepperData={setStepperData}
            setFetchApiFlag={setFetchApiFlag}
            fetchApiFlag={fetchApiFlag}
            country={country}
            rateCardType={rateCardType}
            level={level}
          />
        </TabPanel>
      </div>
    </>
  );
};

export default CommercialsBilling;
